//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const MultiFactorAuthentication: FeatureFlag = {"Id":"MultiFactorAuthentication","Label":"Enable multi-factor authentication for WI logins","Impact":"Enable the WI multi-factor authentication areas","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
